import { render, staticRenderFns } from "./PostAdd.vue?vue&type=template&id=c9d93928&scoped=true&lang=pug&"
import script from "./PostAdd.vue?vue&type=script&lang=js&"
export * from "./PostAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9d93928",
  null
  
)

export default component.exports